var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.completed)?_c('CompletedMessage',{attrs:{"translations":_vm.translations}}):(_vm.failedMessage || _vm.errors.length)?_c('ErrorMessage',{attrs:{"failed-message":_vm.failedMessage,"errors":_vm.errors}}):_c('InProgressMessage',{attrs:{"translations":_vm.translations}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }